import type { RootState } from "types/redux";

export const getUser = (state: RootState) => state.user.data;
